// extracted by mini-css-extract-plugin
module.exports = {"titleContainer":"TitleContainer_titleContainer__Y1G78","text":"TitleContainer_text__ECCMO"};